angular.module("vgresiduos").controller("OutdatedVersionCtrl", [
	"$scope",
	"$rootScope",
	function ($scope, $rootScope) {
		"use strict";

		$scope.labels = $rootScope.labels;
	}
]);
